import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "root d-flex align-items-center" }
const _hoisted_2 = { class: "filler" }
const _hoisted_3 = { class: "operator-descr" }
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 0,
  class: "group-descr"
}

import {computed, ref} from 'vue';
import OperatorAvatar from "~/chat/vue/widget/tabs/chat/OperatorAvatar.vue";
import {OperatorsStore} from "~/chat/ts/store/Operators";
import {ConfigStore} from "~/chat/ts/store/Config";
import {ChatTabStore} from "~/chat/ts/store/ChatTab";
import {IOperator} from "~/chat/ts/data/IOperator";
import MessageSender from "~/chat/ts/service/messages/MessageSender";


const __default__ = {
    name: "ChatHeader"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let showGroupTitle = ref(false);
let overridedGroupTitle = ref<string>();

let selectedOperatorAndGroup = OperatorsStore.selected;

let selectedOperator = computed<IOperator>(() => {
    if (ChatTabStore.isBotRunning.value || ChatTabStore.chatTabMode.value.bot) {
        return OperatorsStore.getBotOperator();
    }
    let result = selectedOperatorAndGroup.value.operator;
    if (!result) {
        if (ChatTabStore.chatTabMode.value.showFirstOperatorWhenNoneIsSelected) {
            result = OperatorsStore.operatorsList.value.find(operator => !OperatorsStore.isOperatorExistInHiddenGroups(operator));
        }
    } else if (MessageSender.isNeedToAskForOperator && commonOperatorParams.value) {
        if (!OperatorsStore.balanceType.value.selectRandomOperator) {
            result = null;
        }
    }
    return result;
});

let selectedGroup = computed(() => {
    return !ChatTabStore.isBotRunning.value ? selectedOperatorAndGroup.value.group : null;
});

let commonOperatorParams = computed(() => {
    return OperatorsStore.balanceType.value.canUseCommonOperatorParams ? OperatorsStore.balanceParams.value.smart : null;
});


let operatorName = computed(() => {
    let result: string = null;
    overridedGroupTitle.value = null;
    let newShowGroupTitle = true;
    if (selectedOperator.value) {
        result = selectedOperator.value.fio;
        if (selectedOperator.value.isBot) {
            overridedGroupTitle.value = botConfig.value.subDescr;
        }
    } else if (ChatTabStore.isOfflineFormButtonDisplayed.value) {
        result = ConfigStore.siteParams.value.params.leadGen.tabTitle;
        newShowGroupTitle = false;
    } else if (commonOperatorParams.value) {
        result = commonOperatorParams.value.descr;
        newShowGroupTitle = false;
        overridedGroupTitle.value = commonOperatorParams.value.subDescr;
    }
    showGroupTitle.value = newShowGroupTitle;
    return result;
});

let botConfig = computed(() => ConfigStore.siteParams.value.params.bot);

let operatorAvatar = computed(() => {
    if (selectedOperator.value) {
        if (selectedOperator.value.isBot) {
            if (!botConfig.value.isAvatarEnabled) {
                return null;
            }
        }
        return selectedOperator.value.avatar;
    } else if (ChatTabStore.isOfflineFormButtonDisplayed.value) {
        return null;
    } else if (commonOperatorParams.value) {
        let avatar = commonOperatorParams.value.avatar;
        if (avatar) {
            if (commonOperatorParams.value.isBase64) {
                avatar = `data:image/png;base64,${avatar}`;
            }
        }
        return avatar;
    }
    return null;
});

let groupTitle = computed(() => {
    if (overridedGroupTitle.value) {
        return overridedGroupTitle.value;
    }
    if (showGroupTitle.value) {
        if (selectedGroup.value) {
            if (ConfigStore.siteParams.value.params.designParams.displayOperatorGroupDescr) {
                return selectedGroup.value.descr;
            }
        } else if (selectedOperator.value) {
            return "Online";
        } else if (commonOperatorParams.value) {
            return commonOperatorParams.value.subDescr;
        }
    }
    return null;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(operatorAvatar) && !_unref(ConfigStore).siteParams.value.free)
      ? (_openBlock(), _createBlock(OperatorAvatar, {
          key: 0,
          class: "header-avatar",
          src: _unref(operatorAvatar),
          name: _unref(operatorName) || _unref(groupTitle)
        }, null, 8, ["src", "name"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(operatorName))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_unref(selectedOperator) && _unref(selectedOperator).link)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _unref(selectedOperator).link,
                    class: "operator-link",
                    target: "_blank"
                  }, _toDisplayString(_unref(operatorName)), 9, _hoisted_4))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(operatorName)), 1)
                  ], 64))
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_unref(groupTitle)), 1)
            ], 64))
      ]),
      (_unref(operatorName) && _unref(groupTitle))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(groupTitle)), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})